// Lib
import { createStructuredSelector, createSelector } from 'reselect';

// Util
import { getMany, toArray } from '../../../../../common/utils/immutableHelper';
import { createShallowSelector } from '../../../../utils/milanoteReselect/milanoteReselect';
import { canSave } from '../../../../../common/permissions/permissionUtil';
import {
    getCreatedTime,
    getElementId,
    getIsImageUploaded,
    getPlatform,
} from '../../../../../common/elements/utils/elementPropertyUtils';
import { isImage, isTask } from '../../../../../common/elements/utils/elementTypeUtils';
import { getPermission } from '../../../../../common/permissions/elementPermissionsUtil';
import { sortByCreatedDesc } from '../../../../../common/elements/utils/elementSortUtils';

// Selector
import { getElements } from '../../../../element/selectors/elementsSelector';
import { getElementChildrenSorted } from '../../../../element/selectors/elementChildrenSelector';
import {
    getCurrentUserQuickNotesRootBoardId,
    getCurrentUser,
    getCurrentUserId,
    getLastCheckedQuickNotes,
} from '../../../../user/currentUserSelector';
import popupOpenSelector from '../../../../components/popupPanel/popupOpenSelector';
import { getGridSize } from '../../../../utils/grid/gridSizeSelector';
import { getElementFilterQuerySelector } from '../../../../element/elementFilter/elementFilterSelector';
import { getQuickNotesElementsDeep } from './quickNotesElementsSelector';

// Constants
import { PopupIds } from '../../../../components/popupPanel/popupConstants';
import { isApplicationPlatformMobile } from '../../../../../common/platform/applicationPlatformUtils';

const quickNotesPermissionsSelector = createSelector(
    getElements,
    getCurrentUserQuickNotesRootBoardId,
    getCurrentUserId,
    getPermission,
);

const isQuickNotesEditableSelector = createSelector(quickNotesPermissionsSelector, canSave);

const quickNotesChildIdsFiltered = createShallowSelector(getElementChildrenSorted(), (children) =>
    children
        .filter((element) => !isImage(element) || getIsImageUploaded(element))
        .map(getElementId)
        .toArray(),
);

export const quickNotesChildrenSelector = createShallowSelector(
    quickNotesChildIdsFiltered,
    getElements,
    (quickNotesElementIds, elements) => getMany(quickNotesElementIds, elements).sort(sortByCreatedDesc),
);
export const quickNotesChildArraySelector = createSelector(quickNotesChildrenSelector, toArray);

export const quickNotesPopupSelector = createStructuredSelector({
    quickNotesRootId: getCurrentUserQuickNotesRootBoardId,
});

const getNewQuickNotesCountSelector = createShallowSelector(
    getQuickNotesElementsDeep,
    getLastCheckedQuickNotes,
    (quickNotesElements, lastCheckedQuickNotes) =>
        quickNotesElements.filter(
            (el) =>
                !isTask(el) &&
                getCreatedTime(el) > lastCheckedQuickNotes &&
                isApplicationPlatformMobile(getPlatform(el)),
        ).size,
);

export const quickNotesUtilSelector = createStructuredSelector({
    currentUser: getCurrentUser,
    quickNotesChildIds: quickNotesChildIdsFiltered,
    popupOpen: popupOpenSelector(PopupIds.QUICK_NOTES),
    gridSize: getGridSize,
    permissions: quickNotesPermissionsSelector,
    query: getElementFilterQuerySelector,
    newQuickNotesCount: getNewQuickNotesCountSelector,
    isEditable: isQuickNotesEditableSelector,
});

export const mobileQuickNotesPageSelector = createStructuredSelector({
    quickNotesChildIds: quickNotesChildIdsFiltered,
    permissions: quickNotesPermissionsSelector,
    query: getElementFilterQuerySelector,
    isEditable: isQuickNotesEditableSelector,
});
